import React, { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { v4 } from 'uuid';

export const RenderInPortal = ({ children }: { children: ReactNode }) => {
  const [element, setElement] = React.useState<Element | null>(null);

  React.useEffect(() => {
    if (!element) {
      const el = document.createElement('div');
      el.id = v4();
      document.body.appendChild(el);

      setElement(el);
    }

    return () => {
      element?.parentNode?.removeChild(element);
    };
  }, [element]);

  if (!element) {
    return null;
  }

  return createPortal(children, element);
};
